import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { Box, Stack } from '@mui/system';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { paths } from 'src/paths';
import MissingDocsList from '../document-management/missing-docs-list';
import ReCheckIcon from './Frame 45111977.png';

type Props = {
  handleDelete: any;
  title: string;
  message: string;
  buttontext?: string;
  episodeOfCareId?: string;
  requiredDocument: boolean;
  document: any;
  source?: string
};

const DischargeRecheckModal = (props: Props) => {
  const { handleDelete, title, message, buttontext, episodeOfCareId, requiredDocument, document, source } =
    props;
  const { patients, patientDetails, episodeOfCare, details, createDocument } = paths;
  const navigate = useNavigate();
  const activeTab = useSelector((state: any) => state.switchDisciplineReducer);
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);
  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data
  );
  const requireRecheck = permissionData?.currentPermissions?.includes(
    'Override ReCheck for Discharge'
  );
  const [agree, setAgree] = useState(false);
  const handleChangesStatus = (e: any) => {
    setAgree(e?.target?.checked);
  };

  const handleContinue = () => {
    if (source === 'DASHBOARD') {
      navigate('/document/document-edit', {
        state: {
          document: document,
        },
      });
    } else {
      navigate(`${patients}/${patientDetails}${episodeOfCare}${details}${createDocument}`, {
        state: {
          document,
          activeTab,
          patientData,
          episodeOfCareId,
          requiredDocument: requiredDocument,
        },
      });
    }

  };

  return (
    <Box p={3}>
      <>
        <DialogContent>
          <Box sx={{ display: 'flex' }}>
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <img
                  alt="recheck"
                  src={ReCheckIcon}
                />
                <Typography variant="h5">{title}</Typography>
              </Box>
              <Typography
                sx={{ color: '#6C737F', fontWeight: '400', width: '100%' }}
                variant="body2"
                mt={0.2}
              >
                {message}
              </Typography>
            </Box>
          </Box>
          <Box mt={3}>
            <MissingDocsList />
          </Box>
          {requireRecheck && (
            <Stack
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              mt={3}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={agree}
                    onChange={handleChangesStatus}
                  />
                }
                label={
                  <Typography
                    variant="body1"
                    fontWeight="600"
                    flexWrap="wrap"
                  >
                    I&apos;ve reviewed the alerts and approve to discharge
                  </Typography>
                }
              />
            </Stack>
          )}
        </DialogContent>
        <DialogActions>
          {requireRecheck ? (
            <>
              <Button
                variant="text"
                onClick={handleDelete}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleContinue}
                disabled={!agree}
              >
                {'Continue'}
              </Button>
            </>
          ) : (
            <Button
              autoFocus
              variant="contained"
              onClick={handleDelete}
            >
              {buttontext}
            </Button>
          )}
        </DialogActions>
      </>
    </Box>
  );
};

export default DischargeRecheckModal;
